import Vue from 'vue'
import App from './App.vue'
import Vuetify from 'vuetify'
import axios from 'axios'
import Vuex from 'vuex'
import router from './router'
import VueChartkick from 'vue-chartkick'
import Chart from 'chart.js'
import EventHub from 'vue-event-hub'
import Datetime from 'vue-datetime'
import { Chrome } from 'vue-color'
import VueChart from 'vuechart'
import VueTheMask from 'vue-the-mask'

import checkPermission from './helpers/checkPermission'

import config from './../config.json'

Vue.use(Datetime)
Vue.use(VueTheMask)
Vue.use(EventHub)
Vue.use(Chrome)
Vue.use(VueChartkick, {
    adapter: Chart
})
Vue.use(Vuex)
Vue.use(Vuetify)
Vue.component(VueChart.name, VueChart)

import 'vue-datetime/dist/vue-datetime.css'
import 'vuetify/dist/vuetify.min.css'
import 'material-design-icons/iconfont/material-icons.css'

import VuexStore from './store'
const store = new Vuex.Store(VuexStore)

let $barramento = axios.create({
    baseURL: config.api_server
})

let $api = axios.create({
    baseURL: config.api_base
})

let $querotaxiApi = axios.create({
    baseURL: config.api_querotaxi
})


VuexStore.modules.system.state.$barramento      = $barramento
VuexStore.modules.system.state.$api             = $api
VuexStore.modules.system.state.$querotaxiApi    = $querotaxiApi


$barramento.interceptors.request.use(config => {
    config.headers.common['Authorization'] = VuexStore.modules.system.state.token
    return config
  }, err => {
    return Promise.reject(err)
})

$api.interceptors.request.use(config => {
    config.headers.common['Authorization'] = VuexStore.modules.system.state.token

    return config
  }, err => {
    return Promise.reject(err)
})

$querotaxiApi.interceptors.request.use(c => {
    c.headers.common['Authorization'] = config.querotaxi_token

    return c
  }, err => {
    return Promise.reject(err)
})


Vue.use({
    install(Vue) {
        Vue.prototype.$can = checkPermission
    }
})


new Vue({
    el: '#app',
    router,
    store,
    render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js